// External imports
import React, { useEffect, useState, Fragment } from 'react'
import { connect } from 'react-redux'
import { Dropdown, Navbar, Nav, Image } from 'react-bootstrap';
import { NavLink, useHistory } from "react-router-dom";
import { IoIosLock, IoIosContact, IoIosFiling, IoIosArrowDown, IoIosGrid, IoMdCreate, IoMdPerson, IoMdContacts, IoIosCube, IoIosBriefcase, IoIosPeople, IoMdDocument, IoIosPaper, IoIosArchive, IoIosTrendingDown, IoIosTrendingUp, IoMdPaper, IoIosSearch,IoMdSync,IoIosToday, IoIosCloudUpload } from "react-icons/io";
import { FaTruckMoving } from 'react-icons/fa'
import ScrollArea from 'react-scrollbar'
import primeLogo from '../assets/images/powered-by-logo.png'
import primeLogoIcon from '../assets/images/prime-logo-icon.jpg'
import logo from '../assets/images/fat-logo2.png'
import logoIcon from '../assets/images/fat-favicon.png'
import user from '../assets/images/user.png'
import { logoutSuccess } from '../actions/user/userActions'
import { hideSideMenu } from '../actions/uiActions';
import {storeStartEndDates} from '../actions/reports/outBoundReportsActions'
import { useAsyncDebounce } from 'react-table';

const Menu = ({ dispatch, hideSideMenuProp }) => {
    const [userName, setUserName] = useState("")
    const history = useHistory()
    const [reportsDropdown, setReportsDropdown] = useState(false)
    const [inboundDropdown, setInboundDropdown] = useState(false)
    const [outboundDropdown, setOutboundDropdown] = useState(false)
    const [roleId, setRoleId] = useState(0);
    const reportsHandler = () => {
        setInboundDropdown(false)
        setOutboundDropdown(false)
        setReportsDropdown(!reportsDropdown)
    }

    const inboundHandler = () => {
        setOutboundDropdown(false)
        setInboundDropdown(!inboundDropdown)
    }

    const outboundHandler = () => {
        setInboundDropdown(false)
        setOutboundDropdown(!outboundDropdown)
    }
    const outboundReportsHandler = () => {
        dispatch(storeStartEndDates(new Date(),new Date()));
    }
    
    useEffect(() => {
        if (localStorage.getItem("userData")) {
            const userData = localStorage.getItem("userData")
            setUserName(JSON.parse(userData).FirstName)
            setRoleId(JSON.parse(userData).RoleID)
        }
    }, [])

    const logoutHandle = async () => {
        try {
            // alert("logoutHandle")
            dispatch(logoutSuccess())
            history.push('/')
            localStorage.clear()
            localStorage.removeItem('loggedIn', true)
            localStorage.removeItem("userData");
            localStorage.removeItem("products");
            localStorage.removeItem("contacts");
            localStorage.removeItem("barColors");
            localStorage.removeItem("barLabels");
            localStorage.removeItem("clients");
            localStorage.removeItem('dataSync');
        } catch (error) {
        }
    }

    const MyProfileHandle = () => {
        history.push("/my-profile")
    }

    return (
        <React.Fragment>
            <div className="menu">
                <Navbar collapseOnSelect expand="lg" bg="light" variant="light" fixed="top">
                    <Navbar.Brand as={NavLink} to="/dashboard">
                        <Image src={hideSideMenuProp ? logoIcon : logo} alt="Logo" className="logo img-fluid" />
                    </Navbar.Brand>
                    <div className="menu-icon" onClick={() => dispatch(hideSideMenu())}>
                        {/* <IoIosMenu className="icon" /> */}
                        <span className="bar top-bar"></span>
                        <span className="bar mid-bar"></span>
                        <span className="bar bottom-bar"></span>
                    </div>
                    <Dropdown className="user-dropdown ml-auto" alignRight>
                        <Dropdown.Toggle id="dropdown-custom-components">
                            <span className="user-name pr-2">{userName}</span>
                            <Image src={user} alt="User Pic" className="user-avatar" />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item eventKey="1">
                                <span onClick={() => MyProfileHandle()}>
                                    <IoIosContact className="icon" />My Profile
                                </span>
                            </Dropdown.Item>
                            <Dropdown.Item eventKey="2" as={NavLink} to="/change-password"><IoIosLock className="icon" />Change Password</Dropdown.Item>
                            <Dropdown.Item eventKey="3" as={NavLink} to="/change-password" 
                            onClick={(e) => {
                                e.preventDefault()
                                return logoutHandle()
                            }}><IoIosLock className="icon" />Logout</Dropdown.Item>
                            
                            {/* <Dropdown.Item eventKey="3">
                                <span onClick={() => logoutHandle()}><IoIosLock className="icon" />Logout</span>
                            </Dropdown.Item> */}
                        </Dropdown.Menu>
                    </Dropdown>

                </Navbar>
            </div>
            <div className="side-menu">
                <ScrollArea speed={0.8}
                    className="area"
                    contentClassName="scroll-content"
                    horizontal={false}>
                    <div className="sidenav-wrap">
                        <Nav defaultActiveKey="/dashboard" className="flex-column">
                            <Nav.Link as={NavLink} to="/dashboard" title={hideSideMenuProp ? "Dashboard" : ""}><IoIosGrid className="icon" /><span className="text">Dashboard</span></Nav.Link>
                            <Nav.Link as={NavLink} to="/users" title={hideSideMenuProp ? "Users" : ""}><IoMdContacts className="icon" /><span className="text">Users</span></Nav.Link>
                            <Nav.Link title={hideSideMenuProp ? "Reports" : ""} className={reportsDropdown ? "nav-link show-dropdown" : "nav-link"} onClick={reportsHandler}>
                                <IoIosFiling className="icon" /><span className="text">Reports</span><IoIosArrowDown className="dropdown-icon" /></Nav.Link>

                            {reportsDropdown ?
                                <div className="dropdowns">

                                    {/* Inbound Reports */}
                                    <Nav.Link title={hideSideMenuProp ? "Inbound" : ""} className={inboundDropdown ? "nav-link active-dropdown" : "nav-link"} onClick={inboundHandler}>
                                        <IoIosTrendingDown className="icon" /><span className="text">Inbound</span><IoIosArrowDown className="dropdown-icon" /></Nav.Link>

                                    {inboundDropdown ?
                                        <div className="inbound-dropdowns">
                                            <Nav.Link as={NavLink} to="/contacts" title={hideSideMenuProp ? "Contacts" : ""}><IoIosPeople className="icon" /><span className="text">Contacts</span></Nav.Link>
                                            <Nav.Link as={NavLink} to="/inventory-transaction" title={hideSideMenuProp ? "Inventory Transaction" : ""}><IoIosCube className="icon" /><span className="text">Inventory Transaction</span></Nav.Link>
                                            <Nav.Link as={NavLink} to="/invoices" title={hideSideMenuProp ? "Invoices" : ""}><IoMdPaper className="icon" /><span className="text">Invoices</span></Nav.Link>
                                            <Nav.Link as={NavLink} to="/products" title={hideSideMenuProp ? "Products" : ""}><IoIosBriefcase className="icon" /><span className="text">Products</span></Nav.Link>
                                            <Nav.Link as={NavLink} to="/purchase-order" title={hideSideMenuProp ? "Purchase Order" : ""}><IoIosArchive className="icon" /><span className="text">Purchase Order</span></Nav.Link>
                                            <Nav.Link as={NavLink} to="/goods-receipts" title={hideSideMenuProp ? "Goods Receipts" : ""}><IoIosPaper className="icon" /><span className="text">Goods Receipts</span></Nav.Link>
                                            <Nav.Link as={NavLink} to="/salesorder" title={hideSideMenuProp ? "Sales Order" : ""}><IoMdDocument className="icon" /><span className="text">Sales Order</span></Nav.Link>
                                            <Nav.Link as={NavLink} to="/shipments" title={hideSideMenuProp ? "Shipments" : ""}><FaTruckMoving className="icon" /><span className="text">Shipments</span></Nav.Link>
                                        </div> : null}

                                    {/* Outbound Reports */}
                                    <Nav.Link title={hideSideMenuProp ? "Outbound" : ""} className={outboundDropdown ? "nav-link active-dropdown" : "nav-link"} onClick={outboundHandler}>
                                        <IoIosTrendingUp className="icon" /><span className="text">Outbound</span><IoIosArrowDown className="dropdown-icon" /></Nav.Link>
                                    {outboundDropdown ?
                                        <div className="outbound-dropdowns">
                                            <Nav.Link as={NavLink} to="/outbound-reports" title={hideSideMenuProp ? "Outbound Reports" : ""} onClick={outboundReportsHandler}><IoIosFiling className="icon" /><span className="text">Outbound Reports</span></Nav.Link>
                                        </div> : null}
                                    <Nav.Link as={NavLink} to="/track-and-trace" title={hideSideMenuProp ? "Track Trace" : ""}><IoIosSearch className="icon" /><span className="text">Track & Trace</span></Nav.Link>
                                    {/* <Nav.Link as={NavLink} to="/invoiceReports" title={hideSideMenuProp ? "InvoiceReports" : ""}><IoIosFiling className="icon" /><span className="text">Invoice Reports</span></Nav.Link> */}
                                    {/* <Nav.Link as={NavLink} to="/salesFee" title={hideSideMenuProp ? "SalesFee" : ""}><IoIosArchive className="icon" /><span className="text">Sales Fee</span></Nav.Link>
                                        <Nav.Link as={NavLink} to="/catalog" title={hideSideMenuProp ? "Product Catalouge" : ""}><IoIosBook className="icon" /><span className="text">Product Catalog</span></Nav.Link> */}
                                </div>
                                : null}
                            <Nav.Link as={NavLink} to="/task" title={hideSideMenuProp ? "Task" : ""}><IoMdCreate className="icon" /><span className="text">Task</span></Nav.Link>
                            {roleId != 1 && roleId != 2 ? 
                                <Nav.Link as={NavLink} to="/client" title={hideSideMenuProp ? "Client" : ""}><IoMdPerson className="icon" /><span className="text">Client</span></Nav.Link> : ''
                            }                            
                            <Nav.Link as={NavLink} to="/holidays" title={hideSideMenuProp ? "Holidays" : ""}><IoIosToday className="icon" /><span className="text">Holidays</span></Nav.Link>
                            <Nav.Link as={NavLink} to="/dataSync" title={hideSideMenuProp ? "DataSync" : ""}><IoMdSync className="icon" /><span className="text">Data Sync </span></Nav.Link>
                            <Nav.Link as={NavLink} to="/file_imports" title={hideSideMenuProp ? "File Imports" : ""}><IoIosCloudUpload className="icon" /><span className="text">File Imports</span></Nav.Link>
                        </Nav>

                        <div className="powered-by text-center">
                            {hideSideMenuProp ? "" : <span className="d-block mb-2 fs-12 black-color">Designed and Developed By</span>}
                            <a href="http://primetgi.com" target="_blank" className="inline-block" rel="noopener noreferrer">
                                <Image src={hideSideMenuProp ? primeLogoIcon : primeLogo} alt="Prime Logo" />
                            </a>
                        </div>
                    </div>
                </ScrollArea>
            </div>
        </React.Fragment>
    )
}

// Map Redux state to React component props
const mapStateToProps = state => ({
    loading: state.users.loading,
    login: state.users.login,
    hideSideMenuProp: state.uiActions.hideSideMenu
})

// Connect Redux to React
export default connect(mapStateToProps)(Menu)